export default {"src":"/_next/static/media/contactbenevoles.447305af.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};